(function () {
  'use strict';

  function initScrollReveal() {
    var targets = document.querySelectorAll('.reveal-on-scroll');
    if (!targets.length) return;

    if (!('IntersectionObserver' in window)) {
      targets.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15, rootMargin: '0px 0px -8% 0px' });

    targets.forEach(function (el) { observer.observe(el); });

    // Safety net: never let content stay hidden if the observer is
    // throttled/blocked (backgrounded tab, older browser, etc).
    setTimeout(function () {
      targets.forEach(function (el) { el.classList.add('is-visible'); });
      observer.disconnect();
    }, 3000);
  }

  function initStickyNavState() {
    var nav = document.querySelector('[role="navigation"]');
    if (!nav) return;

    var ticking = false;
    function update() {
      if (window.scrollY > 12) {
        nav.classList.add('is-scrolled');
      } else {
        nav.classList.remove('is-scrolled');
      }
      ticking = false;
    }

    window.addEventListener('scroll', function () {
      if (!ticking) {
        window.requestAnimationFrame(update);
        ticking = true;
      }
    }, { passive: true });

    update();
  }

  function initCrystalParallax() {
    var hero = document.querySelector('.crystal-hero');
    var wrap = document.querySelector('.crystal-gem-wrap');
    if (!hero || !wrap) return;
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    if (window.matchMedia && window.matchMedia('(hover: none)').matches) return;

    var maxTilt = 9;
    var ticking = false;
    var pendingX = 0;
    var pendingY = 0;

    function apply() {
      wrap.style.transform = 'rotateY(' + pendingX + 'deg) rotateX(' + pendingY + 'deg)';
      ticking = false;
    }

    hero.addEventListener('mousemove', function (e) {
      var rect = hero.getBoundingClientRect();
      var relX = (e.clientX - rect.left) / rect.width - 0.5;
      var relY = (e.clientY - rect.top) / rect.height - 0.5;
      pendingX = relX * maxTilt * 2;
      pendingY = relY * -maxTilt * 2;

      wrap.classList.add('is-tracking');

      if (!ticking) {
        window.requestAnimationFrame(apply);
        ticking = true;
      }
    });

    hero.addEventListener('mouseleave', function () {
      wrap.classList.remove('is-tracking');
      wrap.style.transform = '';
    });
  }

  function initCrystalDirectory() {
    var grid = document.getElementById('CrystalGrid');
    var searchInput = document.getElementById('CrystalSearch');
    var noResults = document.getElementById('CrystalNoResults');
    var modal = document.getElementById('CrystalModal');
    if (!grid || !modal) return;

    var cards = Array.prototype.slice.call(grid.querySelectorAll('[data-crystal-card]'));
    var modalBody = document.getElementById('CrystalModalBody');
    var lastFocused = null;

    if (searchInput) {
      searchInput.addEventListener('input', function () {
        var query = searchInput.value.trim().toLowerCase();
        var visibleCount = 0;

        cards.forEach(function (card) {
          var haystack = (card.getAttribute('data-name') || '') + ' ' + (card.getAttribute('data-keywords') || '');
          var matches = query === '' || haystack.indexOf(query) !== -1;
          card.classList.toggle('is-hidden', !matches);
          if (matches) visibleCount++;
        });

        if (noResults) {
          noResults.hidden = visibleCount !== 0;
        }
      });
    }

    function openModal(handle) {
      var template = document.getElementById('crystal-detail-' + handle);
      if (!template || !modalBody) return;

      modalBody.innerHTML = '';
      modalBody.appendChild(template.content.cloneNode(true));

      lastFocused = document.activeElement;
      modal.hidden = false;
      document.body.style.overflow = 'hidden';
      modal.querySelector('.crystal-modal__close').focus();
    }

    function closeModal() {
      modal.hidden = true;
      document.body.style.overflow = '';
      if (lastFocused && typeof lastFocused.focus === 'function') {
        lastFocused.focus();
      }
    }

    cards.forEach(function (card) {
      card.addEventListener('click', function () {
        openModal(card.getAttribute('data-crystal'));
      });
    });

    modal.querySelectorAll('[data-crystal-modal-close]').forEach(function (el) {
      el.addEventListener('click', closeModal);
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !modal.hidden) {
        closeModal();
      }
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initScrollReveal();
    initStickyNavState();
    initCrystalParallax();
    initCrystalDirectory();
  });
})();
